import { globalConfig, localeStrings as strings } from 'applicationConfig';

const NO_PAYPAL_MODE = globalConfig.NO_PAYPAL_MODE;

export const gridColumns = [
  {
    cellTemplate: 'tradingVenueGroup',
    field: 'tradingVenueGroupId',
    imgField: 'venueClass',
    columnHeader: strings.registerGrid.businessHeader,
    width: '200px'
  },
  {
    field: 'name',
    columnHeader: strings.registerGrid.tradingVenueHeader,
    width: NO_PAYPAL_MODE ? '370px' : '290px'
  },
  {
    field: 'type',
    columnHeader: strings.registerGrid.typeHeader,
    headerCss: 'trading-type',
    width: '90px'
  },
  {
    field: 'mic',
    cellCss: 'trading-code',
    columnHeader: strings.registerGrid.micHeader,
    width: '90px'
  },
  {
    field: 'delayed',
    headerTemplate: 'thirdDoubleByHeightHeader',
    firstHasFieldName: 'hasOrders',
    secondHasFieldName: 'hasTrades',
    upperHeader: NO_PAYPAL_MODE ? '' : strings.registerGrid.delayHeader,
    downLeftHeader: strings.registerGrid.delayOrderHeader,
    downRightHeader: strings.registerGrid.delayTradeHeader,
    width: NO_PAYPAL_MODE ? '150px' : '115px',
    cellTemplate: 'tradingVenueDoubleCheckbox',
    firstFieldName: 'isDelayedOrders',
    fisrtFieldDisabledName: 'isDelayedOrdersDisabled',
    secondFieldName: 'isDelayedTraders',
    secondFieldDisabledName: 'isDelayedTradersDisabled',
    action: 'onChangeRegisterType'
  }
];

if (!NO_PAYPAL_MODE) {
  gridColumns.splice(-1, 0, {
    field: 'realtype',
    width: '115px',
    firstHasFieldName: 'hasOrders',
    secondHasFieldName: 'hasTrades',
    headerTemplate: 'thirdDoubleByHeightHeader',
    upperHeader: strings.registerGrid.realHeader,
    downLeftHeader: strings.registerGrid.realOrderHeader,
    downRightHeader: strings.registerGrid.realTradeHeader,
    cellTemplate: 'tradingVenueDoubleCheckbox',
    firstFieldName: 'isRealOrders',
    fisrtFieldDisabledName: 'isRealOrdersDisabled',
    secondFieldName: 'isRealTraders',
    secondFieldDisabledName: 'isRealTradersDisabled',
    action: 'onChangeRegisterType'
  });
}

export const gridConfig = {
  isGroupView: true,
  groupField: 'tradingVenueGroupId'
};



// WEBPACK FOOTER //
// ./src/containers/Register/registerGridOptions.js